<template>
    <div class="box" v-if="show === 'true' || show === true" @click.self="close">
        <div class="dataModification">
            <div class="headline">
                <span>{{ title }}</span>
                <span @click.stop="definiteModification">确定修改</span>
            </div>
            <div class="dataInput">
                <input type="text" v-model="value" ref="integralFocusing" @focus="$emit('noDisplay')" @blur="$emit('permittedDisplay')" oninput="value=value.replace(/[^0-9.]/g,'')" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'modifyData',
    data() {
        return {
            value: ''
        }
    },
    props: {
        show: {
            type: String | Boolean,
            default: true
        },
        title: {
            type: String,
            default: '会员编号'
        }
    },
    methods: {
        // 确定修改
        definiteModification() {
            console.log('确认修改')
            this.$emit('setIntegral', this.value) // 更新数据
            this.value = ''
        },
        close() {
            this.value = ''
            this.$emit('closeMode', !this.show)
        }
    }
}
</script>

<style lang="scss" scoped>
.box {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .3);
    z-index: 999;

    .dataModification {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 400px;
        height: 110px;
        padding: 0 10px;
        box-sizing: border-box;
        background-color: #FFFFFF;

        .headline {
            height: 47px;
            border-bottom: 2px solid #f1f1f1;
            display: flex;
            justify-content: space-between;
            align-items: center;
            >span {
                &:first-child {
                    font-weight: bold;
                }
                &:last-child {
                    padding: 8px 25px;
                    border-radius: 3px;
                    color: #FFFFFF;
                    background-color: #1E90FF;
                }
            }
        }

        .dataInput {
            margin-top: 12px;
            height: 40px;
            border: 1px solid #e1e1e1;
            border-radius: 3px;
            >input {
                width: 100%;
                height: 100%;
                font-size: 16px;
                padding: 0 10px;
                box-sizing: border-box;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/paperless/components/dataModificationElement/index.vue